import script from "./ChatResponse.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatResponse.vue?vue&type=script&setup=true&lang=js"

import "./ChatResponse.vue?vue&type=style&index=0&id=4a895324&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a895324"]])

export default __exports__